export default __webpack_public_path__ + "static/media/icon_10.496d9f74.png";